import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
  IconButton,
  CircularProgress,
  Button,
  Box,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import "./editroute.css";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const EditRoutingProfilePage = ({ profile, onClose, onUpdate }) => {

  const [name, setName] = useState(profile?.name || "");
  const [description, setDescription] = useState(profile?.description || "");
  const [errors, setErrors] = useState({});

  const accountNo = localStorage.getItem("CustomerAWSAccountId");
  
  const instanceAlias = localStorage.getItem("instanceName"); // <-- runs once, before admin.js
  const email = localStorage.getItem("Email");
   const username = localStorage.getItem("username")
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
const EncryptedInstanceId=localStorage.getItem("EncryptedId")
  const [enabledRows, setEnabledRows] = useState({
    voice: true,
    chat: false,
    task: false,
  });
  const [contacts, setContacts] = useState({ chat: "", task: "" });
  const [concurrency, setConcurrency] = useState({
    voice: "ROUTE_CURRENT_CHANNEL_ONLY",
    chat: "",
    task: "",
  });


 const [queues, setQueues] = useState(() => {
  const assocQueues = profile?.associatedQueues;

  if (typeof assocQueues === "string" && assocQueues.includes("Priority")) {
    // Support future multiple queues
    const queueStrings = assocQueues
      .split("),")
      .map(q => q.trim().replace(/\)$/, "")); // Remove trailing ")"

    return queueStrings.map((qStr) => {
      const nameMatch = qStr.match(/^(.+?)\s+\(Priority:/);
      const priorityMatch = qStr.match(/Priority:\s*(\d+)/);
      const delayMatch = qStr.match(/Delay:\s*(\d+)/);
      const channelMatch = qStr.match(/Channel:\s*([A-Z, ]+)/i); // case-insensitive match

      return {
        queueName: nameMatch?.[1]?.trim() || "",
        priority: Number(priorityMatch?.[1]) || 0,
        delay: Number(delayMatch?.[1]) || 0,
        channelNames: channelMatch?.[1]
          ?.split(",")
          .map(c => c.trim().toUpperCase()) || [],
        checked: false,
      };
    });
  }

  return [];
});


  const [queueList, setQueueList] = useState([]);
  const [queueError, setQueueError] = useState("");

  // const [defaultname, setdefaultName] = useState(profile?.defaultQueue || "");
  const [defaultname, setdefaultName] = useState(profile?.defaultOutboundQueueName|| "");

  const [defaultSelected, setDefaultnames] = useState(profile?.defaultQueue || "");

  const [isChecked, setIsChecked] = useState(
  profile?.agentAvailabilityTimer === "TIME_SINCE_LAST_INBOUND"
);

  // ✅ Advanced settings
  const [showTags, setShowTags] = useState(false);
  // const [storedTags] = useState(profile?.tags || []);
const [storedTags, setStoredTags] = useState(() => {
  if (typeof profile?.tags === "object" && profile.tags !== null) {
    return Object.entries(profile.tags).map(([key, value]) => `${key}:${value}`);
  } else if (typeof profile?.tags === "string" && profile.tags.includes(":")) {
    return profile.tags.split(",").map(tag => tag.trim());
  } else {
    return []; // fallback to empty array
  }
});

  // ✅ Loading states
  const [loading, setLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [actionClicked, setActionClicked] = useState(null); 
  // ✅ Fetch Queue List
  const handleQueueList = async () => {
    const payload = {
      ID:EncryptedInstanceId,
      awsAccount: accountNo,
      region: region,
      InstanceAlias: instanceAlias,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.displayOutboundQueues.displayQueues,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      const body = response.data?.body ? JSON.parse(response.data.body) : [];
      setQueueList(Array.isArray(body) ? body : [body]);
    } catch (error) {
      console.error("🔥 Error retrieving queue data:", error);
    }
  };

  useEffect(() => {
    handleQueueList();
  }, []);

  const channelOptions = [
  { label: "Voice", value: "VOICE" },
  { label: "Chat", value: "CHAT" },
  { label: "Task", value: "TASK" }
];

  // ✅ Input handlers
  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, Name: "Name is required" }));
    } else {
      setErrors((prev) => ({ ...prev, Name: "" }));
    }
  };

  const handleTableCheckboxChange = (row) => {
    setEnabledRows((prev) => ({
      ...prev,
      [row]: !prev[row],
    }));
  };

  const handleContactChange = (e, row) => {
    const value = e.target.value;
    setContacts((prev) => ({ ...prev, [row]: value }));
    if (!value || Number(value) < 1) {
      setErrors((prev) => ({
        ...prev,
        [`${row}-contacts`]: "Must be at least 1",
      }));
    } else {
      setErrors((prev) => ({ ...prev, [`${row}-contacts`]: "" }));
    }
  };

  const handleConcurrencyChange = (e, row) => {
    setConcurrency((prev) => ({
      ...prev,
      [row]: e.target.value,
    }));
  };


const [agentAvailabilityTimer, setAgentAvailabilityTimer] = useState(
  profile?.agentAvailabilityTimer || "TIME_SINCE_LAST_ACTIVITY"
);

const handleCheckboxChangeroute = (event) => {
  const checked = event.target.checked;
  setIsChecked(checked);
  setAgentAvailabilityTimer(
    checked ? "TIME_SINCE_LAST_INBOUND" : "TIME_SINCE_LAST_ACTIVITY"
  );
};


  const toggleShowTags = () => setShowTags((prev) => !prev);

  // ✅ Queue Handling
  const handleAddQueue = () => {
    setQueues((prev) => [
      ...prev,
      {
        id: Date.now(),
        queueName: "",
        channelNames: [],
        priority: "",
        delay: "",
        checked: false,
      },
    ]);
  };

  const handleDeleteQueue = () => {
    setQueues((prev) => prev.filter((q) => !q.checked));
  };

  const handleCheckboxChange = (index) => {
    const updated = [...queues];
    updated[index].checked = !updated[index].checked;
    setQueues(updated);
  };

  const handleQueueNameChange = (index, value) => {
    const updated = [...queues];
    updated[index].queueName = value;
    setQueues(updated);
  };

  const handleChannelChange = (index, value) => {
    const updated = [...queues];
    const selected = updated[index].channelNames || [];
    if (selected.includes(value)) {
      updated[index].channelNames = selected.filter((c) => c !== value);
    } else {
      updated[index].channelNames = [...selected, value];
    }
    setQueues(updated);
  };

  const handleQueueChange = (index, field, value) => {
    const updated = [...queues];
    updated[index][field] = value;
    setQueues(updated);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.Name = "Name is required";
    if (!description.trim()) newErrors.Description = "Description is required";

    if (enabledRows.chat && (!contacts.chat || Number(contacts.chat) < 1)) {
      newErrors["chat-contacts"] = "Must be at least 1";
    }
    if (enabledRows.task && (!contacts.task || Number(contacts.task) < 1)) {
      newErrors["task-contacts"] = "Must be at least 1";
    }

    queues.forEach((queue, idx) => {
      if (!queue.queueName)
        newErrors[`queueName-${idx}`] = "Queue name required";
      if (!queue.channelNames || queue.channelNames.length === 0)
        newErrors[`channelName-${idx}`] = "Select at least one channel";
      if (!queue.priority || Number(queue.priority) < 1)
        newErrors[`priority-${idx}`] = "Priority must be >= 1";
      if (queue.delay < 0) newErrors[`delay-${idx}`] = "Delay must be >= 0";
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCancel = () => {
    setCancelLoading(true);
    setActionClicked("cancel");
    setTimeout(() => {
      setCancelLoading(false);
      setActionClicked(null);
      onClose();
    }, 500);
  };

const fetchRoutingProfile = async () => {
  const payload = {
    ID:EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region: region,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.displayroutes.viewroutes,
      payload
    );

    if (response.data && Array.isArray(response.data)) {
      const extractedData = response.data.map((item) => {
        const associatedQueues = item.AssociatedQueues?.map((queue) => {
          return `${queue.QueueName} (Priority: ${queue.Priority}, Delay: ${queue.Delay}, Channel: ${queue.Channel})`;
        }).join(" | ") || "No Associated Queues";

        const mediaConcurrencies = item.MediaConcurrencies?.map((media) => {
          return `${media.Channel} (Concurrency: ${media.Concurrency}, Behavior: ${media.CrossChannelBehavior?.BehaviorType || "-"})`;
        }).join(" | ") || "No Media Channels";

        const tags = item.Tags
          ? Object.entries(item.Tags)
              .map(([key, value]) => `${key}: ${value}`)
              .join(", ")
          : "No tags";

        return {
          name: item.Name,
          description: item.Description || "No description",
          tags:item.Tags,
          agentAvailabilityTimer: item.AgentAvailabilityTimer || "-",
          defaultOutboundQueueName: item.DefaultOutboundQueueName || "-",
          numberOfAssociatedQueues: item.NumberOfAssociatedQueues || 0,
          numberOfAssociatedUsers: item.NumberOfAssociatedUsers || 0,
          associatedQueues,
          mediaConcurrencies,
        };
      });

      return extractedData;
    } else {
      console.warn("Unexpected response format", response.data);
      return [];
    }
  } catch (error) {
    console.error("❌ Error fetching routing profiles:", error);
    return [];
  }
};

  const handleSave = async () => {
    if (!validateForm()) return;
setActionClicked("save");
    setLoading(true);

    // ✅ Build media concurrency based on selected channels
    const mediaConcurrencies = [
      {
        Channel: "VOICE",
        Concurrency: 1,
        CrossChannelBehavior: { BehaviorType: concurrency.voice },
      },
      {
        Channel: "CHAT",
        Concurrency: parseInt(contacts.chat, 10) || 4,
        CrossChannelBehavior: { BehaviorType: concurrency.chat },
      },
      {
        Channel: "TASK",
        Concurrency: parseInt(contacts.task, 10) || 5,
        CrossChannelBehavior: { BehaviorType: concurrency.task },
      },
    ].filter((item) => enabledRows[item.Channel.toLowerCase()]);

    const queues_names = queues.map((queue) => ({
      QueueName: queue.queueName || "",
      Channel: queue.channelNames.join(", "),
      Priority: Number(queue.priority) || 0,
      Delay: Number(queue.delay) || 0,
    }));

    const requestPayload = {
      action: "update",
      region,
      ID:EncryptedInstanceId,
      awsAccount:customerAWSAccountId,
      InstanceAlias:instanceAlias,
      routing_profile_name: profile?.name, // old name
      name, // new name
      description,
      UserName:username,
       Email:email,
      default_outbound_queue_name: defaultname,
      queue_names: queues_names,
      media_concurrencies: mediaConcurrencies,
      AgentAvailabilityTimer: 0,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.addRoute.newRoute,
        requestPayload
      );
      console.log("✅ Routing profile updated:", response.data);

      // ✅ Build updated profile for parent table
      const updatedProfile = {
        ...profile,
        name,
        description,
        defaultQueue: defaultname,
        queues: queues_names,
        mediaConcurrencies,
      };

      // ✅ Refresh entire routing profile list
const updatedList = await fetchRoutingProfile();
if (updatedList && Array.isArray(updatedList)) {
   onUpdate(updatedList); // update table with latest list
}


      // alert("✅ Routing profile updated successfully!");
      onClose(); // Close modal
    } catch (error) {
      console.error("Error updating routing profile:", error);
      // alert("Failed to update routing profile. Please try again.");
    } finally {
      setLoading(false);
      setActionClicked(null);
    }
  };

  return (
     <Container className="addqueue-content-container">
       <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
  {/* Back Arrow in a circular button */}
  <IconButton
    onClick={onClose}
    size="medium"
    sx={{
      border: "1px solid #ccc",       // border color
      borderRadius: "50%",            // makes it circular
      padding: 1,                     // inner spacing
      bgcolor: "#f5f5f5",             // background color
      "&:hover": { bgcolor: "#e0e0e0" } // hover effect
    }}
  >
    <ArrowBackIcon />
  </IconButton>

  {/* Title */}
  <Typography variant="h4" className="phone-text">
    Edit {name || "Routing Profile"}
  </Typography>
</Box>

     
      <div className="addroute-form-section">
        <h3>Routing profile details</h3>
        <div className="addroute-form-fields">
          <TextField
            label="Name"
            placeholder="Enter Name"
            required
            fullWidth
            value={name}
            onChange={handleNameChange}
            helperText={errors.Name}
            error={!!errors.Name}
          />
          <TextField
            label="Description"
          placeholder="Enter descriptio"
            fullWidth
            required
            inputProps={{ maxLength: 200 }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            helperText={errors.Description}
            error={!!errors.Description}
          />
        </div>
      </div>

    <div className="settings-form-container">
      <h3>Settings</h3>
              <Typography className="addroute-channelheading">
                Channel settings
              </Typography>
         <Typography className="additional-text">
                 Define the channels that can be routed to this group of agents...
               </Typography>
               <table className="custom-table">
          <thead>
            <tr>
              <th>Enable</th>
              <th>Channel</th>
              <th>Max contacts per agent</th>
              <th>Cross-channel concurrency</th>
            </tr>
          </thead>
          <tbody>
            {["voice", "chat", "task"].map((row) => (
              <tr key={row}>
                <td>
                  <Checkbox
                    checked={enabledRows[row]}
                    onChange={() => handleTableCheckboxChange(row)}
                  />
                </td>
                <td className="capitalize">{row}</td>
                <td>
                  {row === "voice" ? (
                    <span>1</span>
                  ) : (
                    <TextField
                      type="number"
                     
                      value={contacts[row]}
                      disabled={!enabledRows[row]}
                      onChange={(e) => handleContactChange(e, row)}
                    />
                  )}
                  {errors[`${row}-contacts`] && (
                    <p style={{ color: "red" }}>{errors[`${row}-contacts`]}</p>
                  )}
                </td>
                <td>
                  <TextField
                    select
                  
                    disabled={!enabledRows[row]}
                    value={concurrency[row]}
                    onChange={(e) => handleConcurrencyChange(e, row)}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="ROUTE_CURRENT_CHANNEL_ONLY">
                      No other channels while agent is on this contact
                    </MenuItem>
                    <MenuItem value="ROUTE_ANY_CHANNEL">
                      Allow other channels concurrently
                    </MenuItem>
                  </TextField>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* QUEUE SECTION */}
      <Box mb={2}>
        <Typography variant="h6">Queues</Typography>
        <Stack direction="row" spacing={2} mt={1} mb={2}>
          <Button variant="contained" onClick={handleAddQueue}>
            ➕ Add Queue
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={handleDeleteQueue}
            disabled={queues.every((q) => !q.checked)}
          >
            🗑 Delete Selected
          </Button>
        </Stack>

        <div className="table-container">
          <table className="queue-table">
            <thead>
              <tr>
                <th />
                <th>Name</th>
                <th>Channels</th>
                <th>Priority</th>
                <th>Delay</th>
              </tr>
            </thead>
            <tbody>
              {queues.map((queue, idx) => (
                <tr key={`${queue.id}-${idx}`}>
                  <td>
                    <Checkbox
                      checked={queue.checked || false}
                      onChange={() => handleCheckboxChange(idx)}
                    />
                  </td>
                  <td>
                    <TextField
                      select
                    
                      value={queue.queueName}
                      onChange={(e) => handleQueueNameChange(idx, e.target.value)}
                      error={!!errors[`queueName-${idx}`]}
                      helperText={errors[`queueName-${idx}`]}
                    >
                      {queueList.map((q, qidx) => (
                        <MenuItem key={qidx} value={q}>
                          {q}
                        </MenuItem>
                      ))}
                    </TextField>
                  </td>
                  <td>
                    {channelOptions.map((channel) => (
  <FormControlLabel
    key={channel.value}
    control={
      <Checkbox
        checked={queue.channelNames?.includes(channel.value)}
        onChange={() => handleChannelChange(idx, channel.value)}
      />
    }
    label={channel.label}
  />
))}

                    {errors[`channelName-${idx}`] && (
                      <p style={{ color: "red" }}>{errors[`channelName-${idx}`]}</p>
                    )}
                  </td>
                  <td>
                    <TextField
                      type="number"
                     
                      value={queue.priority}
                      onChange={(e) => handleQueueChange(idx, "priority", e.target.value)}
                    />
                    {errors[`priority-${idx}`] && (
                      <p style={{ color: "red" }}>{errors[`priority-${idx}`]}</p>
                    )}
                  </td>
                  <td>
                    <TextField
                      type="number"
                    
                      value={queue.delay}
                      onChange={(e) => handleQueueChange(idx, "delay", e.target.value)}
                    />
                    {errors[`delay-${idx}`] && (
                      <p style={{ color: "red" }}>{errors[`delay-${idx}`]}</p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {queueError && <p style={{ color: "red" }}>{queueError}</p>}
      </Box>

     
  <div className="queue-wrapper">
  <Typography className="headingaddroute">
    Default outbound queue
  </Typography>

  <TextField
    placeholder="Select default outbound queue"
    value={defaultname}
    onChange={(e) => setdefaultName(e.target.value)}
    select
    className="edit-queue-select"
  >
    {queueList.map((queue, idx) => (
      <MenuItem
        key={idx}
        value={queue}
        onClick={() => setDefaultnames(queue)}
      >
        {queue}
      </MenuItem>
    ))}
  </TextField>
</div>

      {/* ROUTING ORDER */}
   <Typography className="setroutetext">Set routing order</Typography>

<FormControlLabel 
  control={
    <Checkbox
     sx={{transform: "scale(0.8)", }}
      checked={isChecked}
      onChange={handleCheckboxChangeroute}
    />
  }
  label={
    <Typography fontWeight="bold">
      Outbound calls should not impact routing order
    </Typography>
  }
/>


      {/* ADVANCED SETTINGS */}
      <Box
        display="flex"
        alignItems="center"
        mt={2}
        onClick={toggleShowTags}
        sx={{ cursor: "pointer" }}
      >
        <Typography className="setadvancetext">Show advanced settings</Typography>
        <IconButton size="small">
          {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </IconButton>
      </Box>
      {showTags && storedTags.length > 0 && (
        <Box className="editroutingtags-display">
          <Typography variant="subtitle1">Selected tags</Typography>
          <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {storedTags.map((tag, index) => (
              <Typography
                key={index}
                variant="body1"
                sx={{
                  padding: "3px 6px",
                  backgroundColor: "#0D4CCD80",
                  borderRadius: "8px",
                }}
              >
                {tag}
              </Typography>
            ))}
          </Box>
        </Box>
      )}

      {/* BUTTONS */}
<div className="buttons-addhour">
        <Button onClick={handleCancel} 
           disabled={actionClicked === "save" || cancelLoading}
                >
                  <span className="adduser-button-content">
                    {actionClicked === "cancel" ? (
                      <CircularProgress  size={18} style={{ color: "red" }} />
                    ) : (
                      "Cancel"
                    )}
                            </span>
        </Button>
        <Button variant="contained" onClick={handleSave} 
         disabled={actionClicked === "cancel" || loading}
               >
                 <span className="adduser-button-content">
                   {actionClicked === "save" ? (
                     <CircularProgress size={18} style={{ color: "white" }} />
                   ) : (
                     "Save"
                   )}
                           </span>
        </Button>
      </div>
    </Container>
  );
};

export default EditRoutingProfilePage;
